import { BaseCanvasElement, ImagePlaceholderElement } from "@/typings/customilyElements/canvasElements";
import { ElementType } from "@/typings/designStudio/sourceElementTypes";

export const getElementType = (element: BaseCanvasElement) => {
    if(element.type === 'bounded-text') {
        return ElementType.Text;
    }
    if(element.type === 'image-placeholder' && (element as ImagePlaceholderElement)?.mapConfig) {
        return ElementType.Map;
    }
    return undefined;
}